<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCardHeader class="p-1">
                    <CRow>
                        <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                            <strong>اطلاعات سیستم حضور غیاب</strong>

                        </CCol>
                        <CCol col="4" style="text-align: end">

                            <CButton v-if="items.length>0" @click="send_data()" size="sm"
                                     color="secondary"
                                     class="mr-1">
                                ذخیره نهایی اطلاعات
                            </CButton>
                        </CCol>
                    </CRow>
                </CCardHeader>
            </CCol>
        </CRow>
        <CRow>
            <CCol col="6">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                <strong>بارگذاری فایل</strong>
                            </CCol>
                        </CRow>
                    </CCardHeader>

                    <CCardBody>
                        <CRow>

                            <CCol>
                                <date-picker
                                  type="month"
                                  label="ماه"
                                  v-model="month"/>

                            </CCol>
                            <CCol>
                                <date-picker
                                  type="year"
                                  label="سال"
                                  v-model="year"/>

                            </CCol>
                          <CCol>
                            <CButton
                                size="sm"
                                class="m-1"
                                @click="open_file_selector(1)"
                                color="secondary">انتخاب فایل
                            </CButton>

                          </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>

        </CRow>

        <CInputFile

                ref="file_selector"
                v-show="false"
                v-on:change="handleFileUpload"
        />
        <CCol col="12" v-if="items.length>0">
            <CDataTableFixed
                    :items="items"
                    :fields="fields"
                    column-filter
                    height="350px"
                    hover
                    sorter
                    border
                    striped
            >
              <template #row="{item,index}">
                <td style="text-align: center">
                  <p >{{ index + 1 }}</p>
                </td>
              </template>
            </CDataTableFixed>

        </CCol>
    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import moment from 'moment-jalaali'

    var items = [];

    import Vue from "vue";
    import readXlsxFile from 'read-excel-file'
    export default {
        name: 'Login',
        components: {},
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                name: '',
              month:'',
              year:'',
                file: null,
                export_file_name: '',
                export_modal: false,
                json_data: [],
                items: [],
                fields: [
                  {key: 'row', label: 'ردیف', _style: 'width:10%'},
                  {key: 'name', label: "کارمند", _style: 'width:20%'},
                  {key: 'id', label: "شماره شناسه", _style: 'width:20%;'},
                  {key: 'date', label: "تاریخ", _style: 'width:20%;'},

                ],
                status_form: 0,
                selected_file_type: 0,
              personnel_list:[],
            }
        }, mounted() {
            this.$root.root_validate_errors = [];
            this.month = moment().subtract(1,'month').format('jMM')
            this.year = moment().format('jYYYY')
        this.get_personnel()
      }, watch: {},
        methods: {
          get_personnel() {
            var self = this;
            console.log("route id " + this.$route.params.cat_id);

            const formData = new FormData();


            // formData.append('id', this.selected_province);


            axios.post('/get_personnels',formData, {}).then(function (response) {

              var content_data = response.data;

              // items = content_cats.orders;
              self.personnel_list = content_data


            })
                .catch(function (error) {

                  console.log(error);
                });

          },

            send_data() {
                var self = this;
                const formData = new FormData();
                var url = "insert_present_dates";
                formData.append("items", JSON.stringify(this.items));
                axios.post(url, formData, {}).then(function (response) {

                    // var content_data = response.data;
                    self.$root.modal_component.show_api_response_modals(response);
self.items = [];
                    // if (content_data.statusCode == 0) {
                    //
                    //
                    // } else {
                    //   self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    //
                    // }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            open_file_selector(type) {
                this.selected_file_type = type
                this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
            },
            handleFileUpload(files, e) {
              var self = this
                console.log("handle upload")
                this.file = e.target.files[0];

              var reader = new FileReader();
              reader.onload = function() {
                var text = reader.result;
                var array =  text.split("\r\n");
                // var from_date = moment(this.year + "-" + this.month + "-" + "01").locale('fa')
                // var to_date = moment(this.year + "-" + this.month + "-" + "01").locale('fa').endOf('month');

                // for(var i=array.length-1;i>=0;i--){
                //   var val = array[i];
                //   const date = val.split('\t');
                //   // if(date[1])
                //   const moment_date = moment(date[1],'jYYYY-jMM-jDD HH:mm:ss');
                //   const date_year = moment_date.format('jYYYY');
                //   const date_month = moment_date.format("jMM");
                //   if(date_month==self.month && date_year==self.year){
                //     array_final.push(date);
                //   }
                //
                // }
                array.forEach(function (val){
                  const date = val.split('\t');
                  // if(date[1])
                  const moment_date = moment(date[1],'jYYYY-jMM-jDD HH:mm:ss');
                  const date_year = moment_date.format('jYYYY');
                  const date_month = moment_date.format("jMM");
                  if(date_month==self.month && date_year==self.year){
                    var user = self.personnel_list.filter(x=>x.present_id==date[0].trim());
                    if(user.length>0){
                      self.items.push({
                        'id':date[0].trim(),
                        'date':date[1],
                        'en_date':moment_date.format('YYYY-MM-DD HH:mm:00'),
                        'name':user[0].first_name+" "+user[0].last_name,
                        'user_id':user[0].id
                      }
                        );

                    }
                  }

                })
                // console.log("text is ",self.items)

                // var node = document.getElementById('output');
                // node.innerText = text;
                // console.log(reader.result.substring(0, 200));
              };
              reader.readAsText(this.file);
                // this.read_ecel()

                // var previewImage = URL.createObjectURL(this.file);
              // console.log("file",previewImage)

              // e.target.value = '';
                // e.target.files = '';
            },
            read_ecel() {
                try {
                    if (this.file) {
                        var input = this.$refs.file_selector.$el.getElementsByTagName('input')[0]
                        readXlsxFile(input.files[0]).then((rows) => {
                            // `rows` is an array of rows
                            self.fields = []
                            self.items = []
                            if (rows.length > 0) {
                                for (var i = 0; i < rows.length; i++) {
                                    var row = rows[i];
                                    if (i == 0) {
                                        row.forEach(function (val, index) {
                                            self.fields.push({label: val, key: val})
                                        })
                                    } else {
                                        var item = {};
                                        row.forEach(function (val, index) {
                                            item[rows[0][index]] = val
                                        })
                                        self.items.push(item)
                                    }


                                }

                            }

                            // each row being an array of cells.
                        }).catch((rows) => {
                            alert('Invalid File')
                          console.log("catch ",rows)
                        })
                    }

                } catch (e) {
                  console.log("catch ",e)

                    alert('Invalid File');
                }
                var self = this

            },
            insert_data() {


                if (!this.validateForm()) {
                    // console.log("validate form is false"+this.validate_errors);
                    return true;
                }

                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddMainCat";
                } else {
                    url = "EditMainCat";
                    formData.append('id', this.status_form)

                }

                formData.append('file', this.file);
                formData.append('MainCatTitle', this.name);
                formData.append('Color', this.color);
                formData.append('Code', this.code);
                if (this.$route.params.cat_id != null) {
                    formData.append('IsParent', this.$route.params.cat_id);

                } else {
                    formData.append('IsParent', 0);

                }
                formData.append('summary', this.description);
                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;
                    self.name = '';
                    self.color = '#ffffff';
                    self.code = '';
                    self.description = '';
                    self.previewImage = '/img/placeholder.png';
                    self.get_lists();


                })

                    // axios.post(  '/admin/category', {
                    //     name: self.name,
                    //     description: self.description,
                    //     image: self.image,
                    //     cat: 0,
                    // }).then(function (response) {
                    //     self.name = '';
                    //     self.description = '';
                    //     // localStorage.setItem("api_token", response.data.access_token);
                    //     // self.$router.push({ path: 'notes' });
                    // })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

        }
    }

</script>
